const aboutissue2 = {
    "About the Issue": [
        {
            question: "What are the important details of the Bond offering?",
            answer: "<ul> <li> Issuer Name : InCred Financial Services Limited" +  
                         "<li> Security Name : 9.55% SECURED RATED LISTED REDEEMABLE NON CONVERTIBLE DEBENTURES SERIES II DATE OF MATURITY 13/11/2025" +
                         "<li> ISIN : INE321N07335" + 
                         "<li> Nature of Instrument : Senior, secured, rated, listed, redeemable, taxable, non-convertible debentures" +
                         "<li> Seniority : Senior" +
                         "<li> Date of Issue/ Allotment : 10-Nov-23" +
                         "<li> Credit Rating : CRISIL A+/ Stable" +
                         "<li> Face Value : Rs. 1,000" +
                         "<li> Coupon : Fixed" +
                         "<li> Coupon Rate : 9.55%" +
                         "<li> Coupon Frequency : Quarterly" +
                         "<li> Principal Repayment : Quarterly" +
                         "<li> Original Mode of Issue : Public Issuance" +
                         "<li> Listing Details : Bombay Stock Exchange (BSE)" +
                         "<li> Maturity Date : 13-Nov-25" +
                         "<li> Tenor : 24 Months" +
                         "<li> Debenture Trustee : Catalyst Trusteeship Limited"   
        },
        {
            question: "What is the Security Cover for the Bond?",
            answer: "The Bond is secured by way of a first ranking, exclusive and continuing charge on identified loan receivables for 1.05x the outstanding amount of the Bond (including Interest accrued).",
        },
        {
            question: "What are the important covenants that the Issuer has to adhere to?",
            answer: "a. Debt/Equity <=4.0x" + "<br>" +
                    "b. Gross NPA <6%" + "<br>" +
                    "c. Capital Adequacy Ratio >20% or such higher threshold as may be prescribed by the RBI from time to time."
        },
        {
            question: "Can I liquidate the bond before maturity?",
            answer: "Yes, you can liquidate the bond before maturity through our anytime liquidation feature. However, the liquidation will happen at a discount of 2% to the value of the bond."
        },
        {
            question: "How is the Yield to Maturity (YTM) is calculated?",
            answer: "The Yield to Maturity is calculated using the XIRR formula present in Microsoft Excel or such other spreadsheets. The cash flow is populated in the spreadsheet along with the dates and the XIRR formula is then applied to get the YTM."
        }
    ]

}

export default aboutissue2;